import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ element, allowedRoles = [] }) => {
  const token = localStorage.getItem("authToken");
  const userRole = localStorage.getItem("role");

  // If no token, redirect to home
  if (!token) {
    return <Navigate to="/" replace />;
  }

  // If allowedRoles is specified and user role is not in allowed roles, redirect to home
  if (allowedRoles.length > 0 && !allowedRoles.includes(userRole)) {
    return <Navigate to="/" replace />;
  }

  return element;
};

export default PrivateRoute;
